const dom = {
  $body: $('body'),
  $html: $('html'),
  $document: $(document),
  $window: $(window),
};

export default dom;
